// plugins/loading.ts
export default defineNuxtPlugin(() => {
  const { open, close } = useDialog()

  return {
    provide: {
      dialog: {
        open,
        close,
      },
    },
  }
})
